import { render, staticRenderFns } from "./WorkPermitTNC.vue?vue&type=template&id=66d8434a&scoped=true&"
import script from "./WorkPermitTNC.vue?vue&type=script&lang=js&"
export * from "./WorkPermitTNC.vue?vue&type=script&lang=js&"
import style0 from "./WorkPermitTNC.vue?vue&type=style&index=0&id=66d8434a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d8434a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66d8434a')) {
      api.createRecord('66d8434a', component.options)
    } else {
      api.reload('66d8434a', component.options)
    }
    module.hot.accept("./WorkPermitTNC.vue?vue&type=template&id=66d8434a&scoped=true&", function () {
      api.rerender('66d8434a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/settings/engineers/regionConfig/WorkPermitTNC.vue"
export default component.exports